export default "__VITE_ASSET__CaaMi_1M__"